export default {
  ApiUrl: 'https://api.factory.elevate-tech.sg',
  azureAPIKey: '6032fa4e135b4ffa886cb3369e0e704a',
}
